import React from "react";

import { BusinessAccount } from "../../../../datatypes/businessaccounts/BusinessAccount";

type Props = {
    businessAccount: BusinessAccount | undefined | null;
    smallVersion?: boolean;
};

export function BusinessAccountAbbreviationCircle(props: Props) {
    //if this is null, that is fine, it takes the background color from the css class
    const backgroundColor = props.businessAccount?.color;
    const letters = props.businessAccount?.abbreviation;
    const sizeClass = props.smallVersion
        ? "m-profilePicture-isSmall m-compositeDropdown-triggerIcon"
        : "m-profilePicture-isMedium";
    const marginClass = props.smallVersion ? " no-right-margin" : "";
    return (
        <div className={"m-profilePicture " + sizeClass}>
            <div className={"m-profilePicture-button" + marginClass}>
                <div
                    className="m-profilePicture-abbreviation"
                    style={{
                        backgroundColor: backgroundColor
                    }}>
                    {letters}
                </div>
            </div>
        </div>
    );
}
